'use client';

import { createContext, useContext, useMemo, useState } from 'react';
import { findPhoneNumbersInText } from 'libphonenumber-js';

interface ContextType {
  search: string;
  searchWords: string[];
  setSearch: (search: string) => void;
}

const SearchCustomersContext = createContext<ContextType | null>(null);

export function useSearchCustomersCtx() {
  const ctx = useContext(SearchCustomersContext);
  if (!ctx) {
    throw new Error('useSearchCustomersCtx must be used within a SearchCustomersProvider');
  }
  return ctx;
}

interface Props {
  children: React.ReactNode;
}

export function SearchCustomersProvider({ children }: Props) {
  const [search, setSearch] = useState('');
  const searchWords = useMemo(() => parseSearchWords(search), [search]);
  return (
    <SearchCustomersContext.Provider value={{ search, searchWords, setSearch }}>
      {children}
    </SearchCustomersContext.Provider>
  );
}

function parseSearchWords(search: string): string[] {
  const numbers = findPhoneNumbersInText(search, 'US');
  numbers.sort((a, b) => a.startsAt - b.startsAt);

  // Remove phone numbers from text
  let text = search;
  for (const number of numbers) {
    text = text.slice(0, number.startsAt) + text.slice(number.endsAt);
  }

  const formattedNumbers = numbers.map((number) => number.number.formatNational());

  const words = [...text.split(' '), ...formattedNumbers].filter(Boolean);
  return words;
}
